import { isEqual, isEqualWith, sortBy, uniqWith } from 'lodash';
export const isArrayEqual = (...arrays) => {
    if (arrays.every((arr) => arr.length === 0)) {
        return true;
    }
    const sortedArrays = arrays.map((arr) => sortBy(arr, ['name', 'value']));
    const uniqArrays = sortedArrays.map((arr) => uniqWith(arr, isEqual));
    const [firstArray, ...restArrays] = uniqArrays;
    return restArrays.every((arr) => {
        return (firstArray.length === arr.length &&
            isEqualWith(firstArray, arr, (val1, val2) => val1.name === val2.name && val1.value === val2.value));
    });
};
